// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__W7C32","spin":"Spinner_spin__VHzWl"};